module.exports = __webpack_public_path__ + "img/img3.e7b4c9af.png";